import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Login from "../../../pages/usermanagement/Login";
import Sidebar from "../../common/sidebar/Sidebar";
import DashboardPage from "../../../pages/dashboard/Dashboard";
import ViewOrderPage from "../../../pages/salespage/ViewSalesPage";
import NewOrderPage from "../../../pages/salespage/NewSalesPage";
import ViewProductPage from "../../../pages/productpage/ViewProductPage";
import AddProductPage from "../../../pages/productpage/AddProductPage";
import ViewPurchasePage from "../../../pages/purchase/ViewPurchase";
import NewPurchasePage from "../../../pages/purchase/NewPurchasePage";
import NewExecutivePage from "../../../pages/executive/NewExecutivePage";
import ViewExecutivePage from "../../../pages/executive/ViewExecutivePage";

const Navigation = () => {
  const location = useLocation();
  const logintrue = sessionStorage.getItem("login");
  const isLoggedIn = !!logintrue;
  const showSidebar = isLoggedIn;

  return (
    <>
      <section className="bajajMainSection">
        {showSidebar ? (
          <div className="container-fluid p-0">
            <div className="row g-0">
              <aside className="col-auto p-0 m-0">
                <Sidebar />
              </aside>
              <main className="col" style={{height: "100vh", overflow: "hidden"}}>
                <div className="p-1">
                  <Routes>
                    <Route path="/" element={<DashboardPage />} />
                    <Route path="/viewOrder" element={<ViewOrderPage />} />
                    <Route path="/newOrder" element={<NewOrderPage />} />
                    <Route path="/viewProduct" element={<ViewProductPage />} />
                    <Route path="/addProduct" element={<AddProductPage />} />
                    <Route path="/viewPurchase" element={<ViewPurchasePage />} />
                    <Route path="/newPurchase" element={<NewPurchasePage />} />
                    <Route path="/newExecutive" element={<NewExecutivePage />} />
                    <Route path="/viewExecutive" element={<ViewExecutivePage />} />
                    <Route path="*" element={<DashboardPage />} />
                  </Routes>
                </div>
              </main>
            </div>
          </div>
        ) : (
          <div className="container-fluid p-0 d-flex align-items-center justify-content-center vh-100">
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="*" element={<Login />} />
            </Routes>
          </div>
        )}
      </section>
    </>
  );
};

export default Navigation;
